import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DropDownTypeEnum } from '../../../filter-dropdown/dropdown.component';
import { DropdownItem } from '../../../../../global/types/DropdownItem';
import { WorkingHours } from '../../../../../global/types/WorkingHours';
import { constants } from '../../../../../utils/constants';

interface WorkingHoursChangeEvent {
  updatedWorkingHours: WorkingHours;
  dayIndex: number;
}

@Component({
  selector: 'app-working-hours',
  templateUrl: './working-hours-section.component.html',
  styleUrls: ['./working-hours-section.component.less'],
})
export class WorkingHoursSectionComponent implements OnInit {
  @Input() isEdit: boolean;
  @Input() workingHours: WorkingHours[] = [];
  @Output() workingHoursChange = new EventEmitter<WorkingHoursChangeEvent>();

  timeOptions = constants.timeDropdownOptions;
  selectedStartHours: DropdownItem[] = [];
  selectedEndHours: DropdownItem[] = [];

  get DropDownTypeEnum() {
    return DropDownTypeEnum;
  }

  ngOnInit(): void {
    this.workingHours.forEach((workingHour, i) => {
      this.selectDefaultTimeValues(i);
    });
  }

  getDayName(dayIndex: number): string {
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return daysOfWeek[dayIndex] || '';
  }

  toggleDay(dayIndex: number): void {
    const updatedWorkingHours: WorkingHours = { ...this.workingHours[dayIndex] };
    updatedWorkingHours.isAvailable = !updatedWorkingHours.isAvailable;

    if (updatedWorkingHours.isAvailable) {
      updatedWorkingHours.startHour = 9;
      updatedWorkingHours.startMinute = 0;
      updatedWorkingHours.endHour = 17;
      updatedWorkingHours.endMinute = 0;
    }

    this.workingHours[dayIndex] = updatedWorkingHours;
    this.selectDefaultTimeValues(dayIndex);
    this.workingHoursChange.emit({ updatedWorkingHours, dayIndex });
  }

  onWorkingHoursChange(timeType: 'startHour' | 'endHour', dayIndex: number, event): void {
    const [hoursStr, minutesStr] = event?.value?.split(':') || [];
    const hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10);

    const updatedWorkingHours: WorkingHours = { ...this.workingHours[dayIndex] };
    updatedWorkingHours[timeType] = hours;
    updatedWorkingHours[`${timeType.replace('Hour', 'Minute')}`] = minutes;

    this.updateSelectedHours(timeType, dayIndex, event);
    this.workingHoursChange.emit({ updatedWorkingHours, dayIndex });
  }

  selectDefaultTimeValues(dayIndex: number) {
    const { isAvailable, startHour, startMinute, endMinute, endHour } = this.workingHours[dayIndex];

    if (isAvailable) {
      this.selectedStartHours[dayIndex] = this.findMatchingTimeOption(startHour, startMinute) || this.timeOptions[18];
      this.selectedEndHours[dayIndex] = this.findMatchingTimeOption(endHour, endMinute) || this.timeOptions[34];
    } else {
      this.selectedStartHours[dayIndex] = this.timeOptions[0];
      this.selectedEndHours[dayIndex] = this.timeOptions[0];
    }
  }

  private findMatchingTimeOption(hour: number, minute: number): DropdownItem {
    const formattedTime = `${hour}:${minute === 0 ? '00' : '30'}`;

    return this.timeOptions.find((option) => option.value === formattedTime) || this.timeOptions[0];
  }

  private updateSelectedHours(timeType: 'startHour' | 'endHour', dayIndex: number, event): void {
    const index = this.timeOptions.findIndex((option) => option.value === event.value);
    this.selectedHoursByType(timeType)[dayIndex] = this.timeOptions[index];
  }

  private selectedHoursByType(timeType: 'startHour' | 'endHour'): DropdownItem[] {
    return timeType === 'startHour' ? this.selectedStartHours : this.selectedEndHours;
  }
}
